import { render, staticRenderFns } from "./ArrowRightIconLong.vue?vue&type=template&id=55e039e1"
import script from "./ArrowRightIconLong.vue?vue&type=script&lang=js"
export * from "./ArrowRightIconLong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports